import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { checkResellReversal, revertResell } from 'lib/api/funds';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { showAlert } from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

interface RevertResellProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  resellToRevert: { id: number } | string | number | null;
  triggerSearch: () => Promise<void>;
}

const RevertResell: React.FC<RevertResellProps> = (props) => {
  const { open, setOpen, resellToRevert, triggerSearch } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [canRevert, setCanRevert] = useState(false);
  const [reason, setReason] = useState('');

  const getResellId = (): number | string | null => {
    if (resellToRevert === null) return null;
    if (typeof resellToRevert === 'object' && 'id' in resellToRevert) {
      return resellToRevert.id;
    }
    return resellToRevert;
  };

  const resellId = getResellId();

  const handleRevertResell = async () => {
    if (!resellId) return;
    setLoading(true);
    try {
      await revertResell(dispatch, { id: resellId });
      showAlert(dispatch, 'success', 'Venta revertida correctamente');
      await triggerSearch();
      setOpen(false);
    } catch (error) {
      console.error(error);
      showAlert(dispatch, 'error', 'Error al reversar la venta');
    }
    setLoading(false);
  };

  const fetchIfReversalIsPossible = async () => {
    if (!resellId) return;
    setLoading(true);
    try {
      const response = await checkResellReversal(dispatch, {
        id: resellId,
      });
      setCanRevert(response.canRevert);
      setReason(response.message);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    void fetchIfReversalIsPossible();
  }, [resellToRevert]);

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Revertir la venta a fondo #{resellId}</DialogTitle>
      <DialogContent>
        {loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              minHeight: '100px',
            }}
          >
            <CenteredCircularProgress type="dialog" />
          </div>
        ) : (
          <Typography>{reason}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={() => setOpen(false)}>
          Cancelar
        </CustomButton>
        <CustomButton
          color="primary"
          onClick={handleRevertResell}
          disabled={!canRevert}
        >
          Revertir
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default RevertResell;
